import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

/** Handles expired sessions (401) and unprovisioned users (403) for every API call. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const isAuthCall = req.url.startsWith('/api/v1/me') || req.url.startsWith('/api/v1/auth/');

  return next(req).pipe(
    catchError((error: unknown) => {
      if (auth.enabled && !isAuthCall && error instanceof HttpErrorResponse) {
        const code = (error.error as { error?: { code?: string } } | null)?.error?.code;
        if (error.status === 401) {
          auth.markUnauthenticated();
          auth.login();
        } else if (error.status === 403 && (code === 'USER_NOT_PROVISIONED' || code === 'USER_DISABLED')) {
          auth.markNotProvisioned(code);
          void router.navigate(['/access-pending']);
        }
      }
      return throwError(() => error);
    }),
  );
};
